(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bmg-offer-banner"] && !Shopify.designMode) return;
  try {
    
function initOfferBanner(root){
if(root.dataset.timerReady)return;root.dataset.timerReady='true';
const start=Date.parse(root.dataset.start),end=start+259200000,editor=root.dataset.editor==='true';
function tick(){const now=Date.now(),active=root.dataset.enabled==='true'&&Number.isFinite(start)&&now>=start&&now<end;root.hidden=!active&&!editor;const seconds=active?Math.max(0,Math.floor((end-now)/1000)):259200;root.querySelector('[data-banner-clock]').textContent=[Math.floor(seconds/3600),Math.floor(seconds%3600/60),seconds%60].map(n=>String(n).padStart(2,'0')).join(' : ');}
tick();const timer=setInterval(()=>{if(!root.isConnected){clearInterval(timer);return;}tick();},1000);
}
document.querySelectorAll('[data-offer-banner]').forEach(initOfferBanner);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-offer-banner]').forEach(initOfferBanner));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bmg-print-collection"]) return;
  try {
    

(() => {
 async function init() {
  const root = document.querySelector('[data-bmg-catalogue]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const grid = root.querySelector('.bmg-print-shop__grid');
  const edition = root.querySelector('[data-bmg-edition-filter]');
  const sort = root.querySelector('[data-bmg-sort]');
  const editionPills = [...root.querySelectorAll('[data-bmg-edition-choice]')];
  const sortPills = [...root.querySelectorAll('[data-bmg-sort-choice]')];
  const priceOrder = root.querySelector('[data-bmg-price-order]');
  const paging = root.querySelector('[data-bmg-paging]');
  const empty = root.querySelector('[data-bmg-filter-empty]');
  const count = root.querySelector('[data-bmg-count]');
  const prev = root.querySelector('[data-bmg-prev]');
  const next = root.querySelector('[data-bmg-next]');
  let cards = [...root.querySelectorAll('[data-edition]')];
  let nextUrl = root.querySelector('[data-bmg-next-page]').dataset.next;
  const dedicatedEdition = ['open','limited','exclusive'].includes(root.dataset.defaultEdition);
  const collectionBase = (root.dataset.bmgCollectionBase || '/collections').replace(/\/$/,'');

  const quickLook = root.querySelector('[data-bmg-quick-look-dialog]');
  const quickImage = quickLook?.querySelector('[data-bmg-quick-look-image]');
  const quickTitle = quickLook?.querySelector('[data-bmg-quick-look-title]');
  const quickEdition = quickLook?.querySelector('[data-bmg-quick-look-edition]');
  const quickProduct = quickLook?.querySelector('[data-bmg-quick-look-product]');
  const quickClose = quickLook?.querySelector('[data-bmg-quick-look-close]');
  let quickTrigger = null;
  function closeQuickLook(){
    if(!quickLook)return;
    if(typeof quickLook.close==='function') quickLook.close(); else quickLook.removeAttribute('open');
  }
  root.addEventListener('click',event=>{
    const button=event.target.closest('[data-bmg-quick-look]');
    if(!button||!root.contains(button))return;
    event.preventDefault();
    quickTrigger=button;
    if(quickImage){quickImage.width=Number(button.dataset.imageWidth)||1;quickImage.height=Number(button.dataset.imageHeight)||1;quickImage.src=button.dataset.image||'';quickImage.alt=button.dataset.alt||button.dataset.productTitle||'';}
    if(quickTitle)quickTitle.textContent=button.dataset.productTitle||'';
    if(quickEdition){quickEdition.textContent=button.dataset.editionLabel||'';quickEdition.hidden=!button.dataset.editionLabel;}
    if(quickProduct)quickProduct.href=button.dataset.productUrl||'#';
    if(typeof quickLook?.showModal==='function')quickLook.showModal();else quickLook?.setAttribute('open','');
  });
  quickClose?.addEventListener('click',closeQuickLook);
  quickLook?.addEventListener('click',event=>{if(event.target===quickLook)closeQuickLook();});
  quickLook?.addEventListener('close',()=>quickTrigger?.focus({preventScroll:true}));
  document.addEventListener('keydown',event=>{if(event.key==='Escape'&&quickLook?.hasAttribute('open'))closeQuickLook();});
  try {
   while (nextUrl) {
    const url = new URL(nextUrl, location.href);
    const response = await fetch(url, {credentials:'same-origin'});
    if (!response.ok) throw new Error('Collection unavailable');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const additional = [...doc.querySelectorAll('[data-bmg-catalogue] [data-edition]')];
    const seen = new Set(cards.map(c => c.dataset.handle));
    additional.forEach(card => {if (!seen.has(card.dataset.handle)) {grid.insertBefore(card, empty);cards.push(card);}});
    const following = doc.querySelector('[data-bmg-next-page]')?.dataset.next;
    if (following === nextUrl) throw new Error('Invalid pagination');
    nextUrl = following;
   }
  } catch (_) {
   root.querySelector('[data-bmg-load-error]').hidden = false;
   edition.disabled = true;
   return;
  }
  cards.forEach((c,i) => c.dataset.order = i);
  const isCuratedSubject = ['outback-australia','wildlife','coast-ocean','forests-water','latest-release'].includes(root.dataset.bmgBrowseCategory);
  const featured = isCuratedSubject ? [] : ['zillie-falls','reach','noah-beach','after-burn-1','apex','boat-shed'];
  const size = 24;
  let page = 1;
  function readURL() {
   const query = new URL(location.href).searchParams;
   const value = dedicatedEdition ? root.dataset.defaultEdition : (query.get('edition') || root.dataset.defaultEdition);
   edition.value = ['all','open','limited','exclusive'].includes(value) ? value : 'all';
   const defaultSort = root.dataset.bmgBrowseCategory === 'latest-release' ? 'created-descending' : 'manual';
   sort.value = query.get('sort_by') || defaultSort;
   if (!sort.value) sort.value = defaultSort;
   page = Math.max(1, parseInt(query.get('bmg_page'),10) || 1);
  }
  function syncQuickControls() {
   editionPills.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.bmgEditionChoice === edition.value)));
   sortPills.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.bmgSortChoice === sort.value)));
   if (priceOrder) {
    const priceSort = sort.value === 'price-ascending' || sort.value === 'price-descending';
    priceOrder.value = priceSort ? sort.value : '';
    priceOrder.classList.toggle('is-active', priceSort);
   }
  }
  function render(writeURL) {
   syncQuickControls();
   const ordered = [...cards].sort((a,b) => {
    switch (sort.value) {
     case 'title-ascending': return a.dataset.title.localeCompare(b.dataset.title);
     case 'title-descending': return b.dataset.title.localeCompare(a.dataset.title);
     case 'price-ascending': return Number(a.dataset.price)-Number(b.dataset.price);
     case 'price-descending': return Number(b.dataset.price)-Number(a.dataset.price);
     case 'created-ascending': return Number(a.dataset.created)-Number(b.dataset.created);
     case 'created-descending': return Number(b.dataset.created)-Number(a.dataset.created);
     case 'manual': {
      const ai=featured.indexOf(a.dataset.handle),bi=featured.indexOf(b.dataset.handle);
      return (ai<0?999:ai)-(bi<0?999:bi) || Number(a.dataset.order)-Number(b.dataset.order);
     }
     default:return Number(a.dataset.order)-Number(b.dataset.order);
    }
   });
   const matches = ordered.filter(c => edition.value === 'all' || c.dataset.edition === edition.value);
   const pages = Math.max(1, Math.ceil(matches.length/size));
   page = Math.min(page,pages);
   cards.forEach(c => c.hidden = true);
   matches.slice((page-1)*size,page*size).forEach(c => {c.hidden=false;grid.insertBefore(c,empty);});
   empty.hidden = matches.length !== 0;
   paging.hidden = matches.length === 0;
   count.textContent = (matches.length ? (page-1)*size+1 : 0) + '–' + Math.min(page*size,matches.length) + ' / ' + matches.length;
   prev.disabled = page === 1;next.disabled = page === pages;
   if (writeURL) {
    const url=new URL(location.href);
    if (dedicatedEdition) url.searchParams.delete('edition'); else url.searchParams.set('edition',edition.value);
    url.searchParams.set('sort_by',sort.value);
    if(page>1)url.searchParams.set('bmg_page',page);else url.searchParams.delete('bmg_page');
    url.searchParams.delete('page');history.pushState(history.state,'',url);
   }
   root.querySelectorAll('.bmg-print-shop__subject-link').forEach(link => {
    const url=new URL(link.href);
    if (dedicatedEdition) {
     url.searchParams.delete('edition');
     url.searchParams.delete('sort_by');
     url.searchParams.delete('bmg_page');
    } else {
     url.searchParams.set('edition',edition.value);
     url.searchParams.set('sort_by',sort.value);
    }
    if (url.pathname === collectionBase + '/latest-release') {
     url.searchParams.delete('sort_by');
     url.searchParams.delete('bmg_page');
    }
    link.href=url.toString();
   });
  }
  root.querySelector('[data-bmg-edition-pills]')?.addEventListener('click',event=>{
   const button = event.target.closest('button[data-bmg-edition-choice]');
   if (!button) return;
   const value = button.dataset.bmgEditionChoice;
   if (!['all','open','limited','exclusive'].includes(value) || value === edition.value) return;
   edition.value = value;
   edition.dispatchEvent(new Event('change',{bubbles:true}));
  });
  root.querySelector('[data-bmg-sort-pills]')?.addEventListener('click',event=>{
   const button = event.target.closest('button[data-bmg-sort-choice]');
   if (!button) return;
   const value = button.dataset.bmgSortChoice;
   if (!['manual','created-descending','created-ascending'].includes(value) || value === sort.value) return;
   sort.value = value;
   sort.dispatchEvent(new Event('change',{bubbles:true}));
  });
  priceOrder?.addEventListener('change',()=>{
   if (!['price-ascending','price-descending'].includes(priceOrder.value)) return;
   sort.value = priceOrder.value;
   sort.dispatchEvent(new Event('change',{bubbles:true}));
  });
  edition.addEventListener('change',()=>{
   if (dedicatedEdition) {
    const handle = {all:'all-works',open:'open-edition',limited:'limited-edition-1',exclusive:'exclusive'}[edition.value];
    if (handle) {
     const target = new URL(collectionBase + '/' + handle,location.href);
     if (target.pathname !== location.pathname) {location.assign(target.toString());return;}
    }
   }
   page=1;render(true);
  });
  sort.addEventListener('change',()=>{page=1;render(true);});
  prev.addEventListener('click',()=>{page--;render(true);root.querySelector('.bmg-print-shop__controls').scrollIntoView({block:'start'});});
  next.addEventListener('click',()=>{page++;render(true);root.querySelector('.bmg-print-shop__controls').scrollIntoView({block:'start'});});
  window.addEventListener('popstate',()=>{readURL();render(false);});
  readURL();render(false);
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bmg-print-information"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initPresentation() {
    document.querySelectorAll('[data-bmg-presentation]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const tabs = [...root.querySelectorAll('[data-bmg-tab]')];
      const panels = [...root.querySelectorAll('[data-bmg-panel]')];
      const standardButtons = [...root.querySelectorAll('[data-bmg-standard-choice]')];
      const premiumButtons = [...root.querySelectorAll('[data-bmg-premium-choice]')];
      const frameSelect = document.querySelector('[data-bmg-frame-finish]');
      const mobileQuery = window.matchMedia('(max-width: 799px)');
      root.querySelectorAll('.bmg-presentation-copy').forEach(copy => {
        if (copy.querySelector('[data-bmg-mobile-copy-toggle]')) return;
        const title = copy.querySelector('h3');
        if (!title) return;
        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'bmg-mobile-copy-toggle';
        toggle.dataset.bmgMobileCopyToggle = '';
        toggle.setAttribute('aria-expanded', 'false');
        toggle.innerHTML = '<span>' + title.textContent + '</span><span aria-hidden="true">+</span>';
        title.insertAdjacentElement('afterend', toggle);
        [...copy.children].forEach(child => {
          if (child !== title && child !== toggle && !child.classList.contains('bmg-kicker')) child.classList.add('bmg-mobile-copy-detail');
        });
        toggle.addEventListener('click', () => {
          const open = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', String(!open));
          copy.classList.toggle('bmg-mobile-copy-open', !open);
        });
      });
      function standard(finish, save) {
        const raw = String(finish || '').trim().toLowerCase();
        const aliases = {'black + black':'black_black','black_black':'black_black','black':'black_black','white + white':'white_white','white_white':'white_white','white':'white_white','natural oak':'oak','oak':'oak'};
        const key = aliases[raw] || 'black_black';
        const productValue = ({black_black:'Black + Black',white_white:'White + White',oak:'Natural Oak'})[key];
        standardButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.bmgStandardChoice === key)));
        root.querySelectorAll('[data-bmg-standard-view]').forEach(view => view.hidden = view.dataset.bmgStandardView !== key);
        if (save && frameSelect) {
          const option = [...frameSelect.options].find(option => option.value.toLowerCase() === productValue.toLowerCase());
          if (option && frameSelect.value !== option.value) { frameSelect.value = option.value; frameSelect.dispatchEvent(new Event('change', {bubbles:true})); }
        }
      }
      standardButtons.forEach(button => button.addEventListener('click', () => standard(button.dataset.bmgStandardChoice, true)));
      if (frameSelect) {
        standard(frameSelect.value, false);
        frameSelect.addEventListener('change', () => standard(frameSelect.value, false));
      }
      premiumButtons.forEach(button => button.addEventListener('click', () => {
        const key = button.dataset.bmgPremiumChoice;
        premiumButtons.forEach(option => option.setAttribute('aria-pressed', String(option === button)));
        root.querySelectorAll('[data-bmg-premium-view]').forEach(view => view.hidden = view.dataset.bmgPremiumView !== key);
        root.querySelectorAll('[data-bmg-premium-note]').forEach(note => note.hidden = note.dataset.bmgPremiumNote !== key);
        document.dispatchEvent(new CustomEvent('bmg:premium-style', {detail:key}));
      }));

      let current = 0;
      function show(index, focus) {
        current = (index + tabs.length) % tabs.length;
        tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === current)); tab.tabIndex = i === current ? 0 : -1; panels[i].hidden = i !== current; });
        root.querySelector('[data-bmg-count]').textContent = String(current + 1).padStart(2, '0') + ' / 04';
        if (focus) tabs[current].focus({preventScroll:true});
      }
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => show(i, false));
        tab.addEventListener('keydown', event => {
          let index;
          if (event.key === 'ArrowRight') index = current + 1;
          if (event.key === 'ArrowLeft') index = current - 1;
          if (event.key === 'Home') index = 0;
          if (event.key === 'End') index = tabs.length - 1;
          if (index !== undefined) { event.preventDefault(); show(index, true); }
        });
      });
      root.querySelector('[data-bmg-previous]').addEventListener('click', () => show(current - 1, false));
      root.querySelector('[data-bmg-next]').addEventListener('click', () => show(current + 1, false));
      let touch;
      const swipe = root.querySelector('[data-bmg-swipe]');
      swipe.addEventListener('touchstart', event => { touch = {x:event.changedTouches[0].clientX,y:event.changedTouches[0].clientY}; }, {passive:true});
      swipe.addEventListener('touchend', event => {
        if (!touch) return;
        const dx = event.changedTouches[0].clientX - touch.x, dy = event.changedTouches[0].clientY - touch.y;
        if (Math.abs(dx) > 65 && Math.abs(dx) > Math.abs(dy) * 1.5) show(current + (dx < 0 ? 1 : -1), false);
        touch = null;
      }, {passive:true});
      document.addEventListener('bmg:presentation', event => {
        const index = tabs.findIndex(tab => tab.dataset.bmgTab === event.detail);
        if (index >= 0) show(index, false);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPresentation); else initPresentation();
  document.addEventListener('shopify:section:load', initPresentation);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bmg-print-offer"] && !Shopify.designMode) return;
  try {
    
async function submitOfferPurchase(config, selection, api) {
  const start = Date.parse(config.start);
  const now = api.now();
  if (!config.enabled || !Number.isFinite(start) || now < start || now >= start + 72 * 3600000) throw new Error('This offer is not currently open. No item has been added.');
  const option = config.options[selection.size + '_' + selection.format];
  if (!option || !/^\d+$/.test(String(option.id))) throw new Error('This option is not ready for purchase yet. No item has been added.');
  let before = await api.request('cart.js');
  if (before.currency !== 'AUD' && api.ensureAUD) { await api.ensureAUD(); before = await api.request('cart.js'); }
  if (before.currency !== 'AUD') throw new Error('This offer is priced in AUD. Please use the Australian storefront to purchase.');
  const campaign = 'reach-72h';
  const prior = before.items.filter(item => item.properties && item.properties._offer === campaign);
  if (prior.some(item => String(item.variant_id) !== String(option.id) || item.properties.Finish !== selection.finish)) throw new Error('There is already a different Reach offer selection in your cart. Review or remove it in your cart before choosing another.');
  if (prior.length > 1) throw new Error('Please review the Reach offer items already in your cart before continuing.');
  if (!prior.length) await api.request('cart/add.js', {items: [{id: String(option.id), quantity: 1, properties: {Finish: selection.finish, 'Image width': selection.size + ' cm', _offer: campaign}}]});
  const cart = await api.request('cart/update.js', {discount: option.code || ''});
  const item = cart.items.find(item => String(item.variant_id) === String(option.id) && item.properties && item.properties._offer === campaign && item.properties.Finish === selection.finish);
  const expected = Math.round(selection.price * 100);
  if (!item || cart.currency !== 'AUD' || item.final_price !== expected || item.final_line_price !== expected * item.quantity || (cart.cart_level_discount_applications || []).length) throw new Error('The offer price could not be confirmed. Checkout has been stopped. Your item may be in your cart; review it before trying again.');
  if (api.now() >= start + 72 * 3600000) throw new Error('The offer has ended. Checkout has been stopped; please review your cart.');
  api.navigate('checkout');
  return cart;
}

function initPrintOffer(root){if(root.dataset.initialized)return;root.dataset.initialized="true";const config=JSON.parse(root.querySelector("[data-offer-config]").textContent);
const checkoutConfig=JSON.parse(root.querySelector('[data-checkout-config]').textContent);
const ui=JSON.parse(root.querySelector('[data-launch-copy]').textContent);
let purchaseBusy=false;
const route=checkoutConfig.route.replace(/\/?$/, '/');
async function buyOffer(purchaseSize,purchaseFinish){
  if(purchaseBusy)return;
  const delivery=getDeliveryPolicy(purchaseSize,purchaseFinish);
  if(delivery.block){
    root.querySelector('#delivery-step')?.scrollIntoView({behavior:'smooth',block:'center'});
    reviewOrder(delivery.state==='pending'?'Enter your delivery postcode before continuing.':delivery.title+'. '+delivery.copy);
    return;
  }
  purchaseBusy=true;
  root.setAttribute('aria-busy','true');
  try{
    await submitOfferPurchase(checkoutConfig,{size:purchaseSize,format:keyFor(purchaseFinish),finish:names[purchaseFinish],price:prices[purchaseSize][keyFor(purchaseFinish)]},{
      now:()=>Date.now(),
      ensureAUD:async()=>{const response=await fetch(route+'localization',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/x-www-form-urlencoded'},body:new URLSearchParams({form_type:'localization',_method:'put',country_code:'AU',return_to:window.location.pathname}).toString()});if(!response.ok)throw new Error('Please select Australia / AUD in the store currency selector, then try again.');},
      request:async(path,body)=>{const response=await fetch(route+path,{method:body?'POST':'GET',credentials:'same-origin',cache:'no-store',headers:{'Content-Type':'application/json','Accept':'application/json'},...(body?{body:JSON.stringify(body)}:{})});const data=await response.json();if(!response.ok)throw new Error(data.description||'Shopify could not process this selection. Please check your cart before retrying.');return data;},
      navigate:path=>window.location.assign(route+path)
    });
  }catch(error){reviewOrder(error.message||'We could not reach checkout. Please check your cart before retrying.');}
  finally{purchaseBusy=false;root.removeAttribute('aria-busy');}
}
const prices=config.prices;
const names={paper:'Print only',black:'Black + Black',white:'White + White',oak:'Natural Oak',acrylic:'Acrylic face mount'};
const notes={paper:'The photograph, without framing or mounting. Arrange your own frame locally and make the finish personal to your home.',black:'Matte black Gallery framing with a black mat for a strong, tonal presentation.',white:'Architectural white Gallery framing with a white mat for a clean, light presentation.',oak:'Natural oak Gallery framing with a white mat for warmth and a softer edge.',acrylic:'The photograph is bonded behind clear acrylic with a supporting backing. A glossy, frameless finish with hidden rear mounting gives it a floating appearance. Consider window reflections when choosing its position.'};
const art=config.art,mock=config.mock;
const galleryMocks={
  black:{url:'https://cdn.shopify.com/s/files/1/0488/2127/2744/files/bmg-gallery-black-black-template-approved.png?v=1790214674',height:53.5912},
  white:{url:'https://cdn.shopify.com/s/files/1/0488/2127/2744/files/bmg-gallery-white-white-template-approved.png?v=1790214682',height:53.3149},
  oak:{url:'https://cdn.shopify.com/s/files/1/0488/2127/2744/files/bmg-gallery-natural-oak-template-approved.png?v=1790214692',height:53.1308}
};
const fullGalleryShots={
  black:{overlay:'https://cdn.shopify.com/s/files/1/0488/2127/2744/files/bmg-gallery-black-full-overlay.png?v=1790238085',left:'10.4972%',top:'29.6501%',width:'79.2127%',height:'35.9116%'},
  white:{overlay:'https://cdn.shopify.com/s/files/1/0488/2127/2744/files/bmg-gallery-white-full-overlay.png?v=1790238098',left:'10.0829%',top:'25.2302%',width:'79.8343%',height:'35.7274%'},
  oak:{overlay:'https://cdn.shopify.com/s/files/1/0488/2127/2744/files/bmg-gallery-oak-full-overlay.png?v=1790238107',left:'11.3950%',top:'26.4273%',width:'77.2099%',height:'33.4254%'}
};
let finish='paper',selected='',size='127',baseSize='127',compareSize='127';
const regular=config.regular;

/* Delivery totals match the current Shopify shipping profile. */
function getDeliveryPolicy(forSize=size,forFinish=finish){
  const country=root.querySelector('#delivery-country')?.value||'AU';
  const printOnly=forFinish==='paper';
  const oversize=String(forSize)==='200';
  if(country==='AU'){
    const surcharge=printOnly?0:(oversize?250:150);
    if(surcharge)return {state:'fixed',block:false,surcharge,badge:'DELIVERY +$'+surcharge,title:forSize+' cm framed/acrylic delivery: $'+surcharge+' AUD',copy:'Specialist delivery within Australia is $'+surcharge+' for this '+forSize+' cm framed or acrylic work, as shown at checkout.',summary:'Australian delivery: $'+surcharge+' AUD.',short:'DELIVERY +$'+surcharge};
    return {state:'included',block:false,surcharge:0,badge:'DELIVERY INCLUDED',title:'Delivery included within Australia',copy:'Delivery included within Australia for your selected print.',summary:'Delivery included within Australia.',short:'DELIVERY INCLUDED WITHIN AUSTRALIA'};
  }
  if(printOnly&&!oversize)return {state:'fixed',block:false,surcharge:150,badge:'DELIVERY +$150',title:'International print delivery: $150 AUD',copy:'International delivery is $150 AUD for 127 cm and 150 cm print-only orders. Availability is confirmed for your address at checkout. Any import duties or local taxes are the recipient’s responsibility.',summary:'International print delivery: $150 AUD.',short:'DELIVERY +$150'};
  return {state:'unavailable',block:true,surcharge:0,badge:'PRINT ONLY INTERNATIONALLY',title:'International orders are print only for this release',copy:'Choose 127 cm or 150 cm Print only to continue. Gallery framing, acrylic and the 200 cm hero size are Australia-only in this 72-hour release.',summary:'International release: 127/150 cm print only.',short:'International print only'};
}
function updateDelivery(){
  const country=root.querySelector('#delivery-country')?.value||'AU';
  const isInternational=country!=='AU';
  const postcodeWrap=root.querySelector('#delivery-postcode-wrap');
  if(postcodeWrap)postcodeWrap.hidden=true;
  const internationalAlert=root.querySelector('#delivery-international-alert');
  if(internationalAlert)internationalAlert.hidden=!isInternational;

  root.querySelectorAll('[data-finish]').forEach(button=>{
    const unavailable=isInternational&&button.dataset.finish!=='paper';
    button.disabled=unavailable;
    button.setAttribute('aria-disabled',String(unavailable));
  });
  const goBig=root.querySelector('#go-big');
  if(goBig)goBig.disabled=isInternational||size==='200';

  const policy=getDeliveryPolicy();
  const result=root.querySelector('#delivery-result');
  if(result){
    result.dataset.status=policy.state;
    root.querySelector('#delivery-badge').textContent=policy.badge;
    root.querySelector('#delivery-title').textContent=policy.title;
    const deliveryCopy=root.querySelector('#delivery-copy');if(deliveryCopy)deliveryCopy.textContent=policy.copy;
  }
  const summary=root.querySelector('#delivery-summary');
  if(summary)summary.textContent=policy.summary;
  root.dataset.deliverySurcharge=String(policy.surcharge||0);
  root.dataset.deliveryShortLabel=policy.short||'Delivery';
  root.dataset.deliveryBlocked=String(policy.block);

  const artworkPrice=Number(prices[size]?.[keyFor(finish)]||0);
  const deliveredTotal=artworkPrice+Number(policy.surcharge||0);
  const checkout=root.querySelector('#checkout');

  const campaign=campaignState();
  if(checkout){
    checkout.disabled=policy.block||campaign!=='open';
    checkout.textContent=campaign==='ended'?ui.ended:campaign!=='open'?ui.not_open:policy.block?ui.delivery_pending:ui.checkout;
  }
  root.querySelector('#sticky-price').textContent=policy.block?money(artworkPrice)+' AUD · '+ui.plus_delivery:money(deliveredTotal)+' AUD · '+ui.estimated_total.toLowerCase();
  const breakdown=root.querySelector('#offer-price-breakdown');
  if(breakdown)breakdown.textContent=ui.artwork+' '+money(artworkPrice)+' + '+ui.delivery.toLowerCase()+' '+(policy.block?'—':money(policy.surcharge||0))+' AUD';
}
function handleDeliveryCountryChange(){
  const country=root.querySelector('#delivery-country')?.value||'AU';
  const internationalAlert=root.querySelector('#delivery-international-alert');
  const internationalCopy=root.querySelector('#delivery-international-copy');
  if(country!=='AU'){
    const previousFinish=finish;
    const previousSize=size;
    let changed=false;
    if(finish!=='paper'){finish='paper';changed=true;}
    if(size==='200'){size=baseSize;compareSize=baseSize;updateRoom();changed=true;}
    if(internationalCopy){
      internationalCopy.textContent=changed
        ? 'International shipping is print only for this 72-hour release. We changed your selection from '+previousSize+' cm · '+names[previousFinish]+' to '+size+' cm · Print only so you can continue.'
        : 'International shipping is print only for this 72-hour release. Gallery framing, acrylic and the 200 cm hero size are Australia-only.';
    }
    if(internationalAlert)internationalAlert.hidden=false;
  }else{
    if(internationalAlert)internationalAlert.hidden=true;
  }
  update();
  updateDelivery();
}
function keyFor(f){return ['black','white','oak'].includes(f)?'frame':f}function money(p){return '$'+p.toLocaleString('en-AU')}
function saving(s,k){return k==='paper'?'72-hour print-only offer':'Framed and acrylic at current catalogue pricing'}
function applyPreview(node,selectedFinish){
  if(!node)return;
  node.style.setProperty('background-repeat','no-repeat','important');
  if(selectedFinish==='paper'){
    node.style.setProperty('background-image','url("'+art+'")','important');
    node.style.setProperty('background-size','contain','important');
    node.style.setProperty('background-position','center','important');
  }else if(galleryMocks[selectedFinish]){
    const frame=galleryMocks[selectedFinish];
    node.style.setProperty('background-image','url("'+frame.url+'"), url("'+art+'")','important');
    node.style.setProperty('background-size','100% 100%, auto '+frame.height+'%','important');
    node.style.setProperty('background-position','center, right top','important');
  }else{
    node.style.setProperty('background-image','url("'+mock+'")','important');
    node.style.setProperty('background-size','200% 200%','important');
    node.style.setProperty('background-position','right bottom','important');
  }
}
function update(){updateUpgrade();const key=keyFor(finish),price=prices[size][key],p=money(price)+' AUD';selected=size+' cm · '+names[finish]+' · '+p;root.querySelector("#" + 'choice').textContent=size+' cm · '+names[finish];root.querySelector("#" + 'total').textContent=p;root.querySelector("#" + 'finish-price').textContent=size+' cm · '+p;root.querySelector("#" + 'finish-heading').textContent=names[finish];root.querySelector("#" + 'finish-copy').textContent=notes[finish];root.querySelector("#" + 'sticky-price').textContent=p+' · '+names[finish];root.querySelector("#" + 'upgrade-cost').textContent=key==='paper'?'No frame or mounting included.':'Add '+money(price-prices[size].paper)+' to the print-only price.';root.querySelector("#" + 'savings').textContent=saving(size,key);root.querySelector("#" + 'final-saving').textContent=saving(size,key);root.querySelector("#" + 'buy-paper').textContent=ui.continue_print+' — '+money(prices[baseSize].paper);root.querySelector("#" + 'buy-finish').textContent=ui.continue_finish+' — '+money(price);root.querySelector("#" + 'go-big').textContent=size==='200'?'200 cm selected':'Upgrade to 200 cm — add '+money(prices['200'][key]-price);root.querySelector("#" + 'go-big').disabled=size==='200';root.querySelector("#" + 'back-size').hidden=false;root.querySelector("#" + 'big-price').textContent='200 cm · '+names[finish]+' · '+money(prices['200'][key])+' AUD total';const preview=root.querySelector("#" + 'product-preview');applyPreview(preview,finish);preview.setAttribute('aria-label',config.title+' — '+names[finish]+(finish==='paper'?' original photograph':' illustrative presentation preview'));const selectedPresentationPreview=root.querySelector('#selected-presentation-preview');if(selectedPresentationPreview){const selectedArt=root.querySelector('#selected-presentation-art');const selectedOverlay=root.querySelector('#selected-presentation-overlay');selectedPresentationPreview.dataset.selectedFinish=finish;const fullShot=fullGalleryShots[finish];if(fullShot&&selectedArt&&selectedOverlay){selectedPresentationPreview.style.setProperty('background-image','none','important');selectedPresentationPreview.style.setProperty('background-color','#f4f1eb','important');selectedArt.hidden=false;selectedOverlay.hidden=false;selectedArt.src=art;selectedArt.style.left=fullShot.left;selectedArt.style.top=fullShot.top;selectedArt.style.width=fullShot.width;selectedArt.style.height=fullShot.height;selectedOverlay.src=fullShot.overlay}else{if(selectedArt)selectedArt.hidden=true;if(selectedOverlay)selectedOverlay.hidden=true;applyPreview(selectedPresentationPreview,finish)}selectedPresentationPreview.setAttribute('aria-label',config.title+' — '+size+' cm — '+names[finish]+' presentation preview')}const selectedPresentationCaption=root.querySelector('#selected-presentation-caption');if(selectedPresentationCaption)selectedPresentationCaption.textContent=size+' cm · '+names[finish];root.querySelector("#" + 'mockup-note').textContent=finish==='paper'?'Original photograph. Print only excludes framing and mounting.':galleryMocks[finish]?'Illustrative Gallery framing preview. Final moulding, mat proportions and outside dimensions are confirmed before production.':'Illustrative acrylic preview. Final mounting details are confirmed before production.';const finalPreview=root.querySelector('#final-preview');applyPreview(finalPreview,finish);finalPreview.setAttribute('aria-label',config.title+' — '+size+' cm — '+names[finish]);root.querySelector('#final-preview-note').textContent=root.querySelector('#mockup-note').textContent;root.querySelectorAll('[data-finish]').forEach(b=>{b.classList.toggle('active',b.dataset.finish===finish);b.setAttribute('aria-pressed',String(b.dataset.finish===finish))});updateDelivery();}
function updateUpgrade(){const k=keyFor(finish),base=prices[baseSize][k],big=prices['200'][k];root.querySelector('#big-total').textContent=money(big)+' AUD';root.querySelector('#big-difference').textContent='Add '+money(big-base)+' to your '+baseSize+' cm selection.';root.querySelector('#upgrade-finish-name').textContent='200 cm upgrade price · '+names[finish];root.querySelector('#back-size').textContent='Keep my '+baseSize+' cm size';root.querySelector('#big-card').classList.toggle('is-selected',size==='200');root.querySelector('#upgrade-confirmation').textContent='Current selection: '+size+' cm · '+names[finish]+'.';}
function reviewOrder(text){root.querySelector("#" + 'review-selection').textContent=text;root.querySelector("#" + 'review').showModal()}
root.querySelectorAll('[name=size]').forEach(e=>e.addEventListener('change',()=>{baseSize=e.value;size=baseSize;compareSize=size;updateRoom();update()}));root.querySelectorAll('[data-finish]').forEach(e=>e.addEventListener('click',()=>{finish=e.dataset.finish;update()}));root.querySelector("#" + 'go-big').addEventListener('click',()=>{size='200';compareSize='200';updateRoom();update();root.querySelector("#" + 'upgrade-confirmation').textContent='Current selection: 200 cm · '+names[finish]+'.'});root.querySelector("#" + 'back-size').addEventListener('click',()=>{size=baseSize;compareSize=baseSize;updateRoom();update();root.querySelector("#" + 'upgrade-confirmation').textContent='Current selection: '+baseSize+' cm · '+names[finish]+'.'});function reviewSelection(paperOnly){if(paperOnly){size=baseSize;finish='paper';compareSize=size;updateRoom();update();}root.querySelector('#order-summary').scrollIntoView({behavior:'smooth',block:'start'});root.dispatchEvent(new Event('offer:selection'))}
root.querySelector('#buy-paper').addEventListener('click',()=>reviewSelection(true));
root.querySelector('#buy-finish').addEventListener('click',()=>reviewSelection(false));
root.querySelector('#checkout').addEventListener('click',()=>buyOffer(size,finish));
function updateRoom(){const widths={'127':21.336,'150':25.2,'200':33.6},heights={'127':'46.9','150':'55.4','200':'73.9'};root.querySelector("#" + 'compare-art').style.width=widths[compareSize]+'%';root.querySelector("#" + 'compare-dimensions').textContent='Preview: '+compareSize+' × '+heights[compareSize]+' cm';root.querySelectorAll('[data-compare]').forEach(b=>{const active=b.dataset.compare===compareSize;b.classList.toggle('active',active);b.setAttribute('aria-pressed',String(active))})}
root.querySelectorAll('[data-compare]').forEach(b=>b.addEventListener('click',()=>{compareSize=b.dataset.compare;updateRoom()}));updateRoom();
root.querySelector('#delivery-country')?.addEventListener('change',handleDeliveryCountryChange);
root.querySelector('#delivery-postcode')?.addEventListener('input',()=>{const input=root.querySelector('#delivery-postcode');if(input)input.value=input.value.replace(/\D/g,'').slice(0,4);updateDelivery();});
updateDelivery();
function campaignState(){const start=Date.parse(checkoutConfig.start),now=Date.now();if(Number.isFinite(start)&&now>=start+72*3600000)return 'ended';if(!checkoutConfig.enabled||!Number.isFinite(start)||now<start)return 'pending';return 'open'}
let lastCampaignState;
function updateClock(){
  const state=campaignState(),start=Date.parse(checkoutConfig.start),end=start+72*3600000;
  const clock=root.querySelector('#clock'),note=root.querySelector('#clock-note'),status=root.querySelector('[data-campaign-status]');
  if(state==='open'){
    const seconds=Math.max(0,Math.floor((end-Date.now())/1000));
    clock.textContent=[Math.floor(seconds/3600),Math.floor(seconds%3600/60),seconds%60].map(n=>String(n).padStart(2,'0')).join(' : ');
    note.textContent=ui.closes+' '+new Date(end).toLocaleString('en-AU',{timeZone:'Australia/Brisbane'})+' AEST';
  }else{
    clock.textContent=state==='ended'?ui.ended:ui.not_open;
    note.textContent=state==='ended'?ui.ended:Number.isFinite(start)&&Date.now()<start?ui.opens+' '+new Date(start).toLocaleString('en-AU',{timeZone:'Australia/Brisbane'})+' AEST':ui.opening_pending;
  }
  if(status){status.hidden=state==='open';status.textContent=state==='ended'?ui.ended:ui.opening_pending;}
  if(lastCampaignState!==state){lastCampaignState=state;updateDelivery();}
}
update();updateClock();const offerClock=setInterval(()=>{if(!root.isConnected){clearInterval(offerClock);return;}updateClock();},1000);
root.querySelector("#maximum-saving").textContent="Framed and acrylic options at current catalogue prices.";
root.querySelector("[data-close-review]").addEventListener("click",()=>root.querySelector("#review").close());
}
document.querySelectorAll("[data-print-offer]").forEach(initPrintOffer);document.addEventListener("shopify:section:load",event=>event.target.querySelectorAll("[data-print-offer]").forEach(initPrintOffer));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bmg-workshop-hub"] && !Shopify.designMode) return;
  try {
    
(function(){
  const root=document.querySelector('[data-workshop-hub]');
  if(!root||root.dataset.ready)return;
  root.dataset.ready='true';
  const views=[...root.querySelectorAll('[data-wh-view]')];
  const modes=[...root.querySelectorAll('[data-wh-mode]')];
  const dashboard=root.querySelector('[data-wh-attendee-screen="dashboard"]');
  const experience=root.querySelector('[data-wh-attendee-screen="experience"]');

  function setMode(mode){
    views.forEach(v=>v.hidden=v.dataset.whView!==mode);
    modes.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.whMode===mode)));
  }
  modes.forEach(b=>b.addEventListener('click',()=>setMode(b.dataset.whMode)));

  root.querySelector('[data-wh-open-experience]')?.addEventListener('click',()=>{dashboard.hidden=true;experience.hidden=false;window.scrollTo({top:0,behavior:'smooth'});});
  root.querySelector('[data-wh-back]')?.addEventListener('click',()=>{experience.hidden=true;dashboard.hidden=false;window.scrollTo({top:0,behavior:'smooth'});});

  const tabs=[...root.querySelectorAll('[data-wh-tab]')];
  const panels=[...root.querySelectorAll('[data-wh-panel]')];
  function setTab(tab){
    tabs.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.whTab===tab)));
    panels.forEach(p=>p.hidden=p.dataset.whPanel!==tab);
  }
  tabs.forEach(b=>b.addEventListener('click',()=>setTab(b.dataset.whTab)));
  root.querySelectorAll('[data-wh-tab-link]').forEach(b=>b.addEventListener('click',()=>setTab(b.dataset.whTabLink)));

  root.querySelector('[data-wh-ack]')?.addEventListener('click',e=>{
    const btn=e.currentTarget;
    btn.textContent='Read';
    btn.disabled=true;
    const state=root.querySelector('[data-wh-ack-state]');
    if(state){state.textContent='ACKNOWLEDGED';state.style.color='#52604d';}
    const dot=root.querySelector('.bmg-wh__dot');if(dot)dot.remove();
  });

  root.querySelectorAll('[data-wh-check]').forEach(input=>{
    const key='wh-check-'+input.dataset.whCheck;
    const saved=sessionStorage.getItem(key);
    if(saved!==null)input.checked=saved==='1';
    input.addEventListener('change',()=>sessionStorage.setItem(key,input.checked?'1':'0'));
  });

  root.querySelector('[data-wh-topic-form]')?.addEventListener('submit',e=>{
    e.preventDefault();
    const form=e.currentTarget;
    const title=form.elements.topic.value.trim();
    if(!title)return;
    const category=form.elements.category.value.toUpperCase();
    const article=document.createElement('article');
    article.className='bmg-wh__topic';
    article.innerHTML='<div><span>'+category+'</span><h3></h3><p>Alex · Cairns, QLD · 0 replies</p></div><button type="button">Open →</button>';
    article.querySelector('h3').textContent=title;
    root.querySelector('[data-wh-topic-list]').prepend(article);
    form.reset();
  });

  root.querySelector('[data-wh-admin-form]')?.addEventListener('submit',e=>{
    e.preventDefault();
    const form=e.currentTarget;
    const title=form.elements.title.value.trim();
    const message=form.elements.message.value.trim();
    if(!title||!message)return;
    const category=form.elements.category.value.toUpperCase();
    const emailed=form.elements.email.checked;
    const ack=form.elements.ack.checked;
    const pinned=form.elements.pin.checked;

    const history=document.createElement('div');
    const left=document.createElement('div');
    left.innerHTML='<span></span><strong></strong><small></small>';
    left.querySelector('span').textContent=category+(pinned?' · PINNED':'');
    left.querySelector('strong').textContent=title;
    left.querySelector('small').textContent='Just now'+(emailed?' · emailed':'');
    const read=document.createElement('b');read.textContent=ack?'0 of 6 read':'Published';
    history.append(left,read);
    root.querySelector('[data-wh-admin-history]').prepend(history);

    const post=document.createElement('article');
    post.className='bmg-wh__update'+(ack?' bmg-wh__update--important':'');
    post.innerHTML='<div class="bmg-wh__update-meta"><span></span><small>Just now · Studio</small></div><h3></h3><p></p>';
    post.querySelector('.bmg-wh__update-meta span').textContent=category+(pinned?' · PINNED':'');
    post.querySelector('h3').textContent=title;
    post.querySelector('p').textContent=message;
    if(ack){
      const a=document.createElement('div');a.className='bmg-wh__ack';a.innerHTML='<span>ACKNOWLEDGEMENT REQUIRED</span><button type="button">Mark as read</button>';post.append(a);
    }
    root.querySelector('[data-wh-update-list]').prepend(post);
    form.reset();
    form.elements.email.checked=true;
  });
})();

  } catch(e) { console.error(e); }
})();
})();
